import React, { useEffect, useState } from "react"

import { formatCountDown } from "src/dateHelpers"
import dayjs from "src/dayjs"

export type CountdownProps = {
  timestamp: string
}

const Countdown: React.FC<CountdownProps> = ({ timestamp }) => {
  const [seconds, setSeconds] = useState(() =>
    Math.max(0, dayjs(timestamp).diff(dayjs(), "seconds"))
  )

  useEffect(() => {
    setSeconds(Math.max(0, dayjs(timestamp).diff(dayjs(), "seconds")))
    const interval = setInterval(() => {
      setSeconds(Math.max(0, dayjs(timestamp).diff(dayjs(), "seconds")))
    }, 1000)
    return () => clearInterval(interval)
  }, [timestamp])

  return seconds < 0 ? null : (
    <time dateTime={timestamp}>{formatCountDown(seconds)}</time>
  )
}

export default Countdown
